import React, { useEffect, useRef, useState } from "react";
// import "primereact/resources/themes/tailwind-light/theme.css";
// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";
import { ListBox } from 'primereact/listbox';
import { SelectButton } from 'primereact/selectbutton';
import { InputMask } from "primereact/inputmask";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tree } from 'primereact/tree';
import kpiService from "@services/kpi.service";
import performanceManagementService from "@services/performanceManagement.service";
import { IrancellAPI } from "@services/irancellservices";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ColorPicker } from 'primereact/colorpicker';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import useLocalStorage from "src/hooks/useLocalStorage";
import strftime from "strftime";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Queries() {
  const [selectedNodes, setselectedNodes] = useState(null);
  const [visibleLoginDialog, setVisibleLoginDialog] = useState(false);
  const [value_ag, setag] = useState("1h");
  const [mtnEmail, setmtnEmail] = useState(null);
  const [mtnPassword, setmtnPassword] = useState(null);
  const [mtnToken, setmtnToken] = useState(null);
  const [selectedKPI, setSelectedKPI] = useState(null);
  const [kpiList, setKpiList] = useState([]);
  const [startDate, setStartDate] = useState('2023-02-27');
  const [endDate, setEndDate] = useState('2023-03-04');
  const [charts, setCharts] = useState({});
  const [chartsList, setChartsList] = useState([]);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [nodeFilterValue, setNodeFilterValue] = useState('');
  const [treeValue, setTreeValue] = useState('');
  const [collapse, setCollapse] = useLocalStorage("plano-menu-collapse", false);
  // filterMatchMode
  const [filterMatchMode, setFilterMatchMode] = useState('contains');

  const toast = useRef(null);
  const kpi_category = useRef({});
  const ag_items = [
    { name: '15 min', value: "15m" },
    { name: 'Hourly', value: "1h" },
    { name: 'Daily', value: "1d" },
  ];
  const [nodes, setNodes] = useState([]);
  const [tree, setTree] = useState([]);
  const [selectedKey, setSelectedKey] = useState('');

  useEffect(() => {
    setTree([
      {
        key: 'H2G',
        label: 'H2G',
        icon: 'pi pi-fw pi-database',
        children: [
          { key: 'huawei-2g-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-2g-CLUSTER_REF', label: 'Sub Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-2g-PROVINCE', label: 'Province', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-2g-CITY', label: 'City', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-2g-SITENAME', label: 'Site', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-2g-CELLNAME', label: 'Sector', icon: 'pi pi-fw pi-file' },
        ]
      },
      {
        key: 'H3G',
        label: 'H3G',
        icon: 'pi pi-fw pi pi-fw pi-database',
        children: [
          { key: 'huawei-3g-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-3g-CLUSTER_REF', label: 'Sub Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-3g-PROVINCE', label: 'Province', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-3g-CITY', label: 'City', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-3g-SITENAME', label: 'Site', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-3g-SECTOR', label: 'Sector', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-3g-CELLNAME', label: 'Cell', icon: 'pi pi-fw pi-file' },
        ]
      },
      {
        key: 'H4G',
        label: 'H4G',
        icon: 'pi pi-fw pi-database',
        children: [
          { key: 'huawei-4g-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-4g-CLUSTER_REF', label: 'Sub Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-4g-PROVINCE', label: 'Province', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-4g-CITY', label: 'City', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-4g-SITENAME', label: 'Site', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-4g-SECTOR', label: 'Sector', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-4g-CELLNAME', label: 'Cell', icon: 'pi pi-fw pi-file' },
        ]
      },
      {
        key: 'T_IG30014',
        label: 'T_IG30014',
        icon: 'pi pi-fw pi-database',
        children: [
          { key: 'T-IG30014-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'T-IG30014-PROVINCE', label: 'Province', icon: 'pi pi-fw pi-file' },
          { key: 'T-IG30014-CITY', label: 'City', icon: 'pi pi-fw pi-file' },
          { key: 'T-IG30014-DeviceName', label: 'Device Name', icon: 'pi pi-fw pi-file' },
          { key: 'T-IG30014-ResourceName', label: 'Resource Name', icon: 'pi pi-fw pi-file' },
        ]
      },
    ]);
    let days = 86400000;
    let today = new Date();
    let before = new Date(today - (7 * days));
    setStartDate(strftime('%F', before));
    setEndDate(strftime('%F', today));
    if (!localStorage.getItem("irancell_tocken")) {
      setVisibleLoginDialog(tree);
    }
  }, []);
  const timezone = new Date().getTimezoneOffset();
  const options = {
    exporting: {
      enabled: true,
    },
    title: {
      text: "",
      margin: 50,
      style: { fontSize: "2rem", fontWeight: "bold" },
    },
    chart: {
      zoomType: "x",
      style: {
        fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
        height: "100%"
      },
      exporting: {
        enabled: false,
      },
    },
    credits: {
      enabled: false,
    },
    // colors: ["#2F5EC4", "#45a5f5"],
    plotOptions: {
      line: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3,
          },
        },
        marker: {
          enabled: false,
        },
      },
      series: {
        allowPointSelect: true,
        dataLabels: {
          // enabled: true,
          // formatter: function () {
          //   var dataMax = this.series.dataMax;
          //   if (this.y === dataMax) {
          //     return this.y;
          //   }
          // },
        },
      },
    },
    time: {
      timezone: "Asia/Tehran",
      timezoneOffset: timezone,
    },
    yAxis: [
      {
        id: "left1",
        lineWidth: 1,
        title: {
          enabled: false,
        },
      },
      {
        id: "left2",
        title: {
          enabled: false,
        },
      },
      {
        id: "right1",
        lineWidth: 1,
        opposite: true,
        title: {
          enabled: false,
        },
      },
      {
        id: "right2",
        lineWidth: 0,
        opposite: true,
        title: {
          enabled: false,
        },
      },
    ],
    xAxis: [
      {
        id: "bottom1",
        type: "datetime",
        labels: {
          style: { fontWeight: "bold" },
          rotation: 90,
          // format: ""
        },
        lineWidth: 1,
        title: {
          enabled: false,
        },
      },
      {
        id: "bottom2",
        type: "datetime",
        labels: {
          style: { fontWeight: "bold" },
          rotation: 90,
          // format: ""
        },
        lineWidth: 1,
        title: {
          enabled: false,
        },
      },
    ],
    tooltip: {
      shared: true,
      crosshairs: true,
    },
    // legend: {
    //   enabled: false,
    // },
    series: [

    ],
  };
  const chartRef = useRef(null);

  const nodeOnFilterValueChange = (filter) => {
    console.log(filter);
    setNodeFilterValue(filter);
  }
  const dialogFooterTemplate = () => {
    return <Button className="h-9 text-sm " label="Ok" icon="pi pi-check" onClick={() => setDialogVisible(false)} />;
  };
  const colorTemplate = (rowData) => {
    return (
      <ColorPicker value={rowData.color} onChange={(e) => onColorChange(e, rowData)} />
    );
  };
  const yAxisTemplate = (rowData) => {
    return (
      <Dropdown className="h-10 w-34 text-xs" optionLabel="label" value={rowData.yAxis} options={yAxisSelectItems} onChange={(e) => onYAxisChange(e, rowData)} />
    );
  };
  const deleteTemplate = (rowData) => {
    return (
      <Button icon="pi pi-times" onClick={() => onDelete(rowData)} className="p-button-rounded p-button-danger p-button-text" />
    );
  };
  const xAxisTemplate = (rowData) => {
    return (
      <Dropdown className="h-10 w-34 text-xs" optionLabel="label" value={rowData.xAxis} options={xAxisSelectItems} onChange={(e) => onXAxisChange(e, rowData)} />
    );
  };
  const onDelete = (rowData) => {
    // console.log("rowData.id2", rowData)
    let [node, kpi] = rowData.id.split("-");
    let newChartlist = chartsList.filter(p => p.id !== rowData.id);
    setChartsList(newChartlist);
    // setNodes(newNodes);
    charts[rowData.id].remove();
    delete charts[rowData.id]
  };
  const onColorChange = (e, rowData) => {
    // console.log(e,rowData);
    charts[rowData.id].update({ color: "#" + e.value });
    rowData.color = "#" + e.value;
  };
const onLogin=(e)=>{

  IrancellAPI.login(mtnEmail,mtnPassword).then((response)=>{
    console.log(response);
  }).catch((e)=>{
    console.log(e);
  })
}
  const xAxisEditor = (props) => {
    return (
      <Dropdown value={props.rowData["xAxis"]} options={xAxisSelectItems}
        onChange={(e) => onXAxisChange(props, e.value)} style={{ width: '100%' }}
        itemTemplate={(option) => {
          return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
        }} />
    );
  }
  const onXAxisChange = (props, value) => {
    chartsList[props.rowIndex].xAxis = value;
    setChartsList(chartsList);
    charts[props.rowData.id].update({ xAxis: value });
  }
  const typeEditor = (props) => {
    return (
      <Dropdown value={props.rowData["type"]} options={chartTypes}
        onChange={(e) => onTypeChange(props, e.value)} style={{ width: '100%' }}
        itemTemplate={(option) => {
          return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
        }} />
    );
  }
  const onTypeChange = (props, value) => {
    chartsList[props.rowIndex].type = value;
    setChartsList(chartsList);
    charts[props.rowData.id].update({ type: value });
  }
  const yAxisEditor = (props) => {
    return (
      <Dropdown value={props.rowData["yAxis"]} options={yAxisSelectItems}
        onChange={(e) => onYAxisChange(props, e.value)} style={{ width: '100%' }}
        itemTemplate={(option) => {
          return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
        }} />
    );
  }
  const onYAxisChange = (props, value) => {
    chartsList[props.rowIndex].yAxis = value;
    setChartsList(chartsList);
    charts[props.rowData.id].update({ yAxis: value });
  }
  const rangeButtonClick = (range) => {
    // console.log(range);
    let days = 86400000;//number of milliseconds in a day
    let today = new Date();
    let before = 0;
    switch (range) {
      case "1D":
        before = new Date(today - (1 * days))
        break;
      case "3D":
        before = new Date(today - (3 * days))
        break;
      case "1W":
        before = new Date(today - (7 * days))
        break;
      case "2W":
        before = new Date(today - (14 * days))
        break;
      case "1M":
        before = new Date(today - (30 * days))
        break;
      default:
        before = new Date(today - (7 * days))
        break;
    }
    setStartDate(strftime('%F', before));
    setEndDate(strftime('%F', today));
  }
  const yAxisSelectItems = [
    { label: 'Left 1', value: 'left1' },
    { label: 'Left 2', value: 'left2' },
    { label: 'Right 1', value: 'right1' },
    { label: 'Right 2', value: 'right2' },
  ];

  const xAxisSelectItems = [
    { label: 'Bottom 1', value: 'bottom1' },
    { label: 'Bottom 2', value: 'bottom2' },
  ];
  const chartTypes = [
    { label: 'line', value: 'line' },
    { label: 'bar', value: 'bar' },
    { label: 'area', value: 'area' },
    { label: 'column', value: 'column' },
  ];
  const clearChart = (e) => {
    for (const chartName in charts) {
      charts[chartName].remove();
      delete charts[chartName];


    }
    setChartsList([]);
    setselectedNodes([]);
    setSelectedKPI([]);
  }
  useEffect(() => {
    if (selectedNodes && selectedKPI && Date.parse(startDate) && Date.parse(endDate) && value_ag) {
      const [vendor, tech, level] = selectedKey.split("-");
      const start_mini = strftime("%m-%d", new Date(startDate));
      const end_mini = strftime("%m-%d", new Date(endDate));
      const date_mini = start_mini + "|" + end_mini;
      // let newNodes = arr1.filter(x => !arr2.includes(x));
      for (const chartName in charts) {
        let [tech, node_name, kpi_name] = chartName.split("|");
        if (selectedKPI.filter(p => p.name === kpi_name).length === 0 || selectedNodes.indexOf(node_name) === -1) {
          // console.log("delete");
          charts[chartName].remove();
          delete charts[chartName]
        }
      }
      let newNode = new Set();
      let newKPI = new Set();
      for (const kpi of selectedKPI) {
        for (const node of selectedNodes) {
          const chartName = tech + "|" + node + "|" + kpi.name + "|" + value_ag + "|" + date_mini;
          // console.log("xnew chart charts", charts);
          // console.log("xnew chart", chartName);
          if (chartName in charts) {
            // console.log("chartNamefOUND", chartName);
          }
          else {

            newNode.add(node);
            newKPI.add(kpi);
          }
        }
      }
      if (newNode.size !== 0 && newKPI.size !== 0) {
        let data = {
          "buket": value_ag,
          "startDate": startDate,
          "endDate": endDate,
          "scope": level,
          "ne_list": Array.from(newNode),
          "kpi_id": Array.from(newKPI),
          "tech": tech
        };
        // console.log("newNode", newNode);
        // console.log("newKPI", newKPI);
        chartRef.current.chart.showLoading();
        performanceManagementService.fetchKpi(data).then((response) => {
          // console.log(response.data)
          for (const chart_data of response.data) {
            // console.log("chart_data.name", chart_data.name);
            charts[chart_data.name] = chartRef.current.chart.addSeries({
              type: "line",
              // id: chart_data.name,
              visible: true,
              yAxis: "left1",
              xAxis: "bottom1",
              name: chart_data.name,
              // color: counter.color,
              data: chart_data.data
            });
            chartRef.current.chart.hideLoading();
            //   charts[chart_data.name].yAxis.update({
            //     opposite: opposite
            // });
            // charts[chart_data.name].update({ yAxis: "left1" });
            // console.log("yAxis", charts[chart_data.name].yAxis);
          }
          let chartsList2 = [];
          for (const key in charts) {
            const ch = charts[key];
            let [tech, node, kpi, bucket, start, end] = ch.name.split("|");
            console.log([tech, node, kpi, bucket, start, end]);
            chartsList2.push({
              id: ch.name,
              tech: tech,
              node: node,
              kpi: kpi,
              bucket: bucket,
              start: start,
              end: end,
              color: ch.color,
              xAxis: ch.xAxis.userOptions.id,
              yAxis: ch.yAxis.userOptions.id,
              type: "line"
            });
          }
          setCharts(charts);
          setChartsList(chartsList2);
          // console.log(charts);

        }).catch((e) => {
          toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
          // console.log(e);
          chartRef.current.chart.hideLoading();
        }
        )
      }
      else {
        // console.log("kpi removed");
      }

    }
  }, [selectedNodes, selectedKPI, startDate, endDate, value_ag]);
  useEffect(() => {
    const [vendor, tech, level] = treeValue.split("-");
    if (nodeFilterValue.indexOf(",") > -1) {
      setFilterMatchMode("notEquals");
    }
    else {
      setFilterMatchMode("contains");
    }

    const [old_vendor, old_tech, old_level] = selectedKey.split("-");
    setSelectedKey(treeValue)
    if (old_tech !== tech) {
      kpiService.fetchKpiFilter({ "tech": tech.toUpperCase() }, {}).then((response) => {
        // console.log(response)m
        setKpiList(response.data);
      }).catch((e) => {
        console.log(e);
      })
    }
    // console.log("sasadasd", treeValue, nodeFilterValue);
    performanceManagementService.fetchETL({ "tech": tech, "level": level, "filter": nodeFilterValue }).then((response) => {
      console.log(response)
      setNodes(response.data);
    })
  }, [treeValue, nodeFilterValue])

  return (
    <div className="flex pt-16 relative  flex-grow h-full ">
      <div className={`h-16 transition-all duration-300 absolute top-0 z-20 w-full flex flex-col bg-white border-b border-gray-200 overflow-hidden `} >
        <div className="  flex bg-white rounded-xl p-3 ">
          <div className="card grid-rows-2 flex justify-content-center text-sm ">
            <InputMask id="startDate_input" value={startDate} className=" p-button-sm text-xs w-36 " onChange={(e) => setStartDate(e.target.value)} mask="9999-99-99" slotChar="yyyy-mm-dd" />
          </div>
          <div className="card flex justify-content-center text-sm">
            <InputMask id="endDate_input" value={endDate} className=" text-xs ml-2 	w-36" onChange={(e) => setEndDate(e.target.value)} mask="9999-99-99" slotChar="yyyy-mm-dd" />
          </div>
          <Button label="1D" className="text-xs ml-2 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("1D")} />
          <Button label="3D" className="text-xs ml-1 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("3D")} />
          <Button label="1W" className="text-xs ml-1 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("1W")} />
          <Button label="2W" className="text-xs ml-1 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("2W")} />
          <Button label="1M" className="text-xs ml-1 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("1M")} />

          {/* <Calendar value={dates} dateTemplate={dateTemplate} required showButtonBar className="p-inputtext-sm text-sm" onChange={(e) => setDates(e.value)} selectionMode="range" readOnlyInput /> */}
          <SelectButton value={value_ag} onChange={(e) => setag(e.value)} className="text-xs ml-2 " optionLabel="name" options={ag_items} />
          {/* <Button icon="pi pi-play" rounded outlined aria-label="Filter" /> */}
          <Button label="Charts Setting" className=" p-button-sm text-xs ml-2 h-10" icon="pi pi-external-link" onClick={() => setDialogVisible(true)} />
          {/* <SelectButton value={value_vendor} onChange={(e) => setVendor(e.value)} className=" p-button-sm text-xs" optionLabel="name" options={vendor_items} />
          <SelectButton value={value_tec} onChange={(e) => settec(e.value)} className=" p-button-sm text-xs" optionLabel="name" options={items} />
          <SelectButton value={value_ph} onChange={(e) => setPH(e.value)} className=" p-button-sm text-xs" optionLabel="name" options={r_items} /> */}
        </div>

      </div>
      <div className="flex flex-grow relative w-full">
        <div className="w-70 flex-shrink-0 bg-white border-r border-gray-200 overflow-auto ">
          <div className={classNames("bg-white rounded-xl ", "focus:outline-none")}>
            <div className="card flex justify-content-center bg-white w-full">
              <Tree selectionMode="single" selectionKeys={selectedKey} onSelectionChange={(e) => setTreeValue(e.value)} value={tree} className="w-full  md:w-30rem text-xs text-container" />
            </div>
          </div>
        </div>
        <div className="w-52 flex-shrink-0 bg-white border-r border-gray-200 overflow-auto">
          <div className={classNames("bg-white rounded-xl p-3  ", "focus:outline-none")}>
            <ListBox
              multiple

              filter
              value={selectedKPI}
              className="w-fit md:w-14rem text-xs text-container"
              listStyle={{ maxHeight: '250px' }}
              onChange={(e) => setSelectedKPI(e.value)} options={kpiList}
              optionLabel="name" />
          </div>
          <div className={classNames("bg-white rounded-xl p-3", "focus:outline-none")}>
            <ListBox
              multiple
              filter
              filterMatchMode={filterMatchMode}
              value={selectedNodes}
              className="w-full md:w-14rem text-xs text-container size"
              listStyle={{ maxHeight: '250px' }}
              filterValue={nodeFilterValue}
              onFilterValueChange={(e) => nodeOnFilterValueChange(e.value)}
              onChange={(e) => setselectedNodes(e.value)} options={nodes}
            />

          </div>
        </div>
        <div className="flex p-5 w-full " style={{ maxWidth: "calc(100vw - 28rem)" }}>
          <div className="flex flex-col h-full w-full">
            <div style={{ height: "100%" }} className={`h-100  bg-white border  border-gray-200 rounded p-5 pt-9`}>
              <HighchartsReact
                ref={chartRef}
                highcharts={Highcharts}
                options={options}
                updateArgs={[true, false, true]}
                containerProps={{ style: { height: 'calc(100vh - 250px)', maxWidth: `calc(100vw - ${collapse ? "30rem" : "40rem"})` } }}

              />
            </div>
          </div>
        </div>
        {/* tech:tech,
              node:node,
              kpi:kpi,
              bucket:bucket,
              start:start,
              end:end, */}
        <Dialog visible={dialogVisible} maximizable
          modal onHide={() => setDialogVisible(false)} footer={dialogFooterTemplate}>
          <Button label="Clear Chart" onClick={clearChart} severity="danger p-button-sm" />
          <DataTable value={chartsList} scrollable scrollHeight="flex" tableStyle={{ minWidth: '50rem' }}>
            <Column body={deleteTemplate}  ></Column>
            <Column field="tech" header="tech"></Column>
            <Column field="node" header="node"></Column>
            <Column field="kpi" header="kpi"></Column>
            <Column field="bucket" header="bucket"></Column>
            <Column field="start" header="start"></Column>
            <Column field="end" header="end"></Column>
            <Column field="color" body={colorTemplate} header="Color"></Column>
            <Column field="yAxis" editor={(props) => yAxisEditor(props)} header="yAxis"></Column>
            <Column field="xAxis" editor={(props) => xAxisEditor(props)} header="xAxis"></Column>
            <Column field="type" editor={(props) => typeEditor(props)} header="Type"></Column>

          </DataTable>
        </Dialog>
        <Dialog header="Login to IOS" visible={visibleLoginDialog} style={{ width: '50vw' }} onHide={() => setVisibleLoginDialog(false)}>
          <Accordion activeIndex={0}>
            <AccordionTab header="Login">
              <div className="card flex justify-content-center">
                <InputText value={mtnEmail}  onChange={(e) => setmtnEmail(e.target.value)} />
              </div>
              <div className="card flex justify-content-center">
                <Password value={mtnPassword}  onChange={(e) => setmtnPassword(e.target.value)} feedback={false} />
              </div>
              <Button label="Submit" onClick={onLogin} />
            </AccordionTab>
            <AccordionTab header="Verify">
              <form>
                <div class="form-group">
                  <label for="exampleInputEmail1">Token</label>
                  <input type="text" class="form-control"  onChange={(e) => setmtnToken(e.target.value)} id="exampleInputEmail1" placeholder="" />
                </div>
                <button type="submit" class="btn btn-primary">Verify</button>
              </form>
            </AccordionTab>

          </Accordion>
        </Dialog>
        <Toast ref={toast} />
      </div>
    </div >
  );
}

export default Queries;




